/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

window.Vue = require('vue').default;
window.Bus = new Vue();

/**
 * Load the localization
 */
import VueI18n from 'vue-i18n';
import Locale from './vue-i18n-locales.generated';

Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: window.Globals.locale,
    messages: Locale,
    pluralizationRules: {
        'ro': function(count, choicesLength) {
            if (count === 0) {
                return 0;
            }
            if (count === 1) {
                return 1;
            }
            if (count > 1 && count < 20) {
                return 2;
            }
            return (choicesLength < 4) ? 2 : 3;
        },
    },
});

window.Globals.unexpectedErrorMessage = i18n.t('globals.unexpected_error');

window.Globals.payuEndpoint = process.env.MIX_PAYU_ENDPOINT;

/**
 * Load the utilities.
 */
require('./utilities/bootstrap');

/**
 * Load the pages main components.
 */
require('./components/bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
    el: '#root',
    i18n
});
